import React from 'react';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { IoMdInformationCircleOutline } from 'react-icons/io';

interface TextInputProps {
	value: string;
	placeholder?: string;
	tooltip?: string;
	label?: string;
	color?: string;
	onChange: (value: string) => void;
	onBlur?: () => void;
	type?: 'text' | 'number';
	className?: string;
}

const TextInput: React.FC<TextInputProps> = ({
	value,
	placeholder = '',
	onChange,
	onBlur,
	className,
	color,
	label,
	tooltip,
	type = 'text',
}) => {
	return (
		<div className="w-full">
			{label && (
				<div className="flex items-center gap-2 mb-2">
					<p className="text-sm font-medium ">{label}</p>
					{tooltip && (
						<div data-tooltip-id={`${label}-1`}>
							<IoMdInformationCircleOutline />
						</div>
					)}
				</div>
			)}
			<ReactTooltip id={`${label}-1`} place="top" content={tooltip} />
			<input
				type={type}
				className={`rounded-lg bg-gray-50 mb-4 border border-gray-300 text-gray-900 focus:outline-none focus:ring-2 ${
					color ? `focus:ring-[${color}]` : 'focus:ring-blue-400'
				}  focus:border-transparent text-sm px-2.5 py-2.5 ${className}`}
				placeholder={placeholder}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				onBlur={onBlur}
			/>
		</div>
	);
};

export default TextInput;
